import { useEffect, useState } from 'react';

import AppButton from '../../../../commons/buttons/AppButton';
import AppContainer from '../../../../commons/containers/AppContainer';
import AppInput from '../../../../commons/inputs/AppInput';
import AppLinkButton from '../../../../commons/buttons/AppLinkButton';
import { Form } from 'react-bootstrap';

/* eslint-disable react-hooks/exhaustive-deps */
function HPStep4({ nextStep, toBack, ruleType, configToEdit }) {

    const [expirationInMonths, setExpirationInMonths] = useState(0);

    const POINTS_FOR_VALUE = 'POINTS_FOR_VALUE'
    const POINTS_FOR_SERVICE = 'POINTS_FOR_SERVICE'
    const POINTS_FOR_PERCENTAGE = 'POINTS_FOR_PERCENTAGE'

    const toNext = () => {
        const data = {
            expirationInMonths: expirationInMonths,
        }
        nextStep(data)
    };

    const getRuleTypeDescription = () => {
        if (ruleType === POINTS_FOR_VALUE) {
            return '[A] Pontos por valor gasto'
        }
        if (ruleType === POINTS_FOR_SERVICE) {
            return '[B] Pontos fixos por serviço'
        }
        if (ruleType === POINTS_FOR_PERCENTAGE) {
            return '[C] Pontos proporcionais ao valor gasto'
        }
    }

    useEffect(() => {
        if (configToEdit != null && Object.keys(configToEdit).length > 0) {
            setExpirationInMonths(configToEdit.pointsInfo.expirationInMonths)
        }
    }, []);

    return (
        <div className="container">
            <h6>A opção escolhida foi: <br></br><b>{getRuleTypeDescription()}</b></h6>
            <hr></hr>

            <Form>
                <label>Os pontos expiram após quantos meses?</label>
                <AppInput
                    label="Meses"
                    name="points"
                    type='number'
                    value={expirationInMonths}
                    errors={[]}
                    onChange={(e) => { setExpirationInMonths(e.target.value) }} />
            </Form>


            <div style={{ marginBottom: '220px' }}></div>


            <div
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '0rem',
                    backgroundColor: '#fff',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
                    zIndex: 1000,
                }}
            >
                <AppContainer>
                    <AppLinkButton name="Próximo" fullWidth={true} onClick={toNext} disabled={expirationInMonths === 0} />

                    <div style={{ marginTop: '10px' }}>
                        <AppButton name="voltar" width="100%" onClick={toBack} />
                    </div>
                </AppContainer>
            </div>
        </div>
    );
}

export default HPStep4;